import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { TENANTS_INFO, COMPANY_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { Store } from '@ngrx/store';
import { ToastMessageService } from '@fitness-force/api';
import { AttachmentService } from '@fitness-force/api';
import { ErrorMsgComponent, NotFoundError } from '@fitness-force/errors';
import { InputTextModule } from 'primeng/inputtext';


@Component({
  selector: 'folder-create-dialog',
  templateUrl: './folder-create-dialog.component.html',

  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    DynamicDialogModule,
    FormsModule,
    ErrorMsgComponent,
    InputTextModule,
    ButtonModule,
    TranslateModule
]
})
export class FolderCreateDialogComponent implements OnInit {
  getAccessTenantList$: Observable<any> = new Observable();
  selectedTenant$: Observable<any> = new Observable();
  tenantId = 0;

  primaryLanguage!: string;
  secondaryLanguage!: string;
  isSecondaryLanguage = new BehaviorSubject<boolean>(false);

  folderForm!: UntypedFormGroup;
  activeFolder: any;
  isSubmitting=false;


  constructor(public ref: DynamicDialogRef, private store: Store,
    public config: DynamicDialogConfig,
    public translate: TranslateService,
    private attachmentService: AttachmentService,
    private toastMessageService: ToastMessageService,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
  ) {
    this.activeFolder = this.config.data?.activeFolder;
  }

  ngOnInit(): void {

    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    combineLatest([
      this.getAccessTenantList$,
      this.store.select(COMPANY_INFO),
    ]).subscribe({
      next: ([tenant, company]: any) => {
        this.tenantId = tenant.selected_tenant.id;
        if (this.tenantId > 0) {
          this.store.dispatch({ type: 'ROUTER_GO' });

            if(tenant.selected_tenant?.secondary_language){
            this.isSecondaryLanguage.next(true);
            this.translate
              .get([
                'common.LANGUAGE.' +
                tenant.selected_tenant.primary_language?.toUpperCase(),
                'common.LANGUAGE.' +
                tenant.selected_tenant.secondary_language?.toUpperCase(),
              ])
              .subscribe((translations) => {
                this.primaryLanguage =
                  translations[
                  'common.LANGUAGE.' +
                  tenant.selected_tenant.primary_language?.toUpperCase()
                  ];
                this.secondaryLanguage =
                  translations[
                  'common.LANGUAGE.' +
                  tenant.selected_tenant.secondary_language?.toUpperCase()
                  ];
                  this.cd.detectChanges();
              });
          }
          this.createFolderForm();
          this.cd.detectChanges();
        }
      },
    });
  }



  createFolderForm() {
    this.folderForm = this.fb.group({
      name_primary_language: [this.activeFolder && this.activeFolder.name_primary_language ? this.activeFolder.name_primary_language : "", Validators.required],
      name_secondary_language: [this.activeFolder && this.activeFolder.name_secondary_language ? this.activeFolder.name_secondary_language : ""],
      description_primary_language: [this.activeFolder && this.activeFolder.description_primary_language ? this.activeFolder.description_primary_language : "",],
      description_secondary_language: [this.activeFolder && this.activeFolder.description_secondary_language ? this.activeFolder.description_secondary_language : ""]
    });

  }
  get Primary(): UntypedFormControl {
    return this.folderForm.get('name_primary_language') as UntypedFormControl
  }
  get Secondary(): UntypedFormControl {
    return this.folderForm.get('name_secondary_language') as UntypedFormControl
  }
  get PrimaryDesc(): UntypedFormControl {
    return this.folderForm.get('description_primary_language') as UntypedFormControl
  }
  get SecondaryDesc(): UntypedFormControl {
    return this.folderForm.get('description_secondary_language') as UntypedFormControl
  }


  saveFolderForm() {
    if (this.folderForm.valid) {
      const data = this.folderForm.value;
      this.isSubmitting=true;
      if (this.activeFolder) {
        this.attachmentService.updateAttachment(this.tenantId, this.activeFolder.id, data).subscribe({
          next: (res: any) => {
            this.isSubmitting=false;
            this.activeFolder = null;
            this.translate
              .get(
                'ADMIN.DOCUMENT.UPDATED_SUCCESS_MESSAGE')
              .subscribe((translations) => {
                this.toastMessageService.showSuccess(translations);
              });
              this.ref.close(res);
          },
          error: (error: any) => {
            this.isSubmitting=false;
            this.handleError(error)
          }
        })
      } else {
        this.attachmentService.createAttachment(this.tenantId, data).subscribe({
          next: (res: any) => {
            this.isSubmitting=false;
            this.translate
              .get(
                'ADMIN.DOCUMENT.CREATE_SUCCESS_MESSAGE')
              .subscribe((translations) => {
                this.toastMessageService.showSuccess(translations);
              });
              this.ref.close(res);
          },
          error: (error: any) => {
            this.isSubmitting=false;
             this.handleError(error)
          }
        })
      }
    } else {
      // Todo Fire all control touches ...
      Object.keys(this.folderForm.controls).forEach((field) => {
        const control = this.folderForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });

      this.cd.detectChanges();
    }
  }

close(){
  this.ref.close();

}

handleError(error: any) {
  if (error instanceof NotFoundError) {
    this.translate
      .get(
        'common.errors.SERVER_SIDE.ERROR_OCCURRED')
      .subscribe((translations: any) => {
        this.toastMessageService.showErrorMessage(translations);
      });
  } else {
    this.translate
      .get(
        'common.errors.SERVER_SIDE.SOMETHING_WRONG')
      .subscribe((translations: any) => {
        this.toastMessageService.showErrorMessage(translations);
      });
  }


}


}
